export default ({driver: {last_name = ''} = {}} = {}) => last_name;
